let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6pEqF")).then(() => parcelRequire('icLxk'));